/**
 * relationship
 *
 * On a Relationship object, describes the type of relationship
 *
 * https://www.w3.org/ns/activitystreams#relationship
 */
export const relationship = 'https://www.w3.org/ns/activitystreams#relationship';
/**
 * Activity
 *
 * An Object representing some form of Action that has been taken
 *
 * https://www.w3.org/ns/activitystreams#Activity
 */
export const Activity = 'https://www.w3.org/ns/activitystreams#Activity';
/**
 * Object
 *
 * undefined
 * Note that `Object` is a reserved Javascript keyword, and is therefore suffixed by `__workaround`.
 * For a list of reserved keywords, see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Lexical_grammar#Keywords.
 *
 * https://www.w3.org/ns/activitystreams#Object
 */
export const Object__workaround = 'https://www.w3.org/ns/activitystreams#Object';
/**
 * Link
 *
 * Represents a qualified reference to another resource. Patterned after the RFC5988 Web Linking Model
 *
 * https://www.w3.org/ns/activitystreams#Link
 */
export const Link = 'https://www.w3.org/ns/activitystreams#Link';
/**
 * Collection
 *
 * An ordered or unordered collection of Objects or Links
 *
 * https://www.w3.org/ns/activitystreams#Collection
 */
export const Collection = 'https://www.w3.org/ns/activitystreams#Collection';
/**
 * CollectionPage
 *
 * A subset of items from a Collection
 *
 * https://www.w3.org/ns/activitystreams#CollectionPage
 */
export const CollectionPage = 'https://www.w3.org/ns/activitystreams#CollectionPage';
/**
 * Image
 *
 * An Image file
 *
 * https://www.w3.org/ns/activitystreams#Image
 */
export const Image = 'https://www.w3.org/ns/activitystreams#Image';
/**
 * OrderedItems
 *
 * A rdf:List variant for Objects and Links
 *
 * https://www.w3.org/ns/activitystreams#OrderedItems
 */
export const OrderedItems = 'https://www.w3.org/ns/activitystreams#OrderedItems';
/**
 * Relationship
 *
 * Represents a Social Graph relationship between two Individuals (indicated by the 'a' and 'b' properties)
 *
 * https://www.w3.org/ns/activitystreams#Relationship
 */
export const Relationship = 'https://www.w3.org/ns/activitystreams#Relationship';
/**
 * Question
 *
 * A question of any sort.
 *
 * https://www.w3.org/ns/activitystreams#Question
 */
export const Question = 'https://www.w3.org/ns/activitystreams#Question';
/**
 * Profile
 *
 * A Profile Document
 *
 * https://www.w3.org/ns/activitystreams#Profile
 */
export const Profile = 'https://www.w3.org/ns/activitystreams#Profile';
/**
 * Tombstone
 *
 * A placeholder for a deleted object
 *
 * https://www.w3.org/ns/activitystreams#Tombstone
 */
export const Tombstone = 'https://www.w3.org/ns/activitystreams#Tombstone';
/**
 * Place
 *
 * A physical or logical location
 *
 * https://www.w3.org/ns/activitystreams#Place
 */
export const Place = 'https://www.w3.org/ns/activitystreams#Place';
/**
 * OrderedCollectionPage
 *
 * An ordered subset of items from an OrderedCollection
 *
 * https://www.w3.org/ns/activitystreams#OrderedCollectionPage
 */
export const OrderedCollectionPage = 'https://www.w3.org/ns/activitystreams#OrderedCollectionPage';
/**
 * Accept
 *
 * Actor accepts the Object
 *
 * https://www.w3.org/ns/activitystreams#Accept
 */
export const Accept = 'https://www.w3.org/ns/activitystreams#Accept';
/**
 * Block
 *
 *
 *
 * https://www.w3.org/ns/activitystreams#Block
 */
export const Block = 'https://www.w3.org/ns/activitystreams#Block';
/**
 * Ignore
 *
 * Actor is ignoring the Object
 *
 * https://www.w3.org/ns/activitystreams#Ignore
 */
export const Ignore = 'https://www.w3.org/ns/activitystreams#Ignore';
/**
 * IntransitiveActivity
 *
 * An Activity that has no direct object
 *
 * https://www.w3.org/ns/activitystreams#IntransitiveActivity
 */
export const IntransitiveActivity = 'https://www.w3.org/ns/activitystreams#IntransitiveActivity';
/**
 * Add
 *
 * To Add an Object or Link to Something
 *
 * https://www.w3.org/ns/activitystreams#Add
 */
export const Add = 'https://www.w3.org/ns/activitystreams#Add';
/**
 * Announce
 *
 * Actor announces the object to the target
 *
 * https://www.w3.org/ns/activitystreams#Announce
 */
export const Announce = 'https://www.w3.org/ns/activitystreams#Announce';
/**
 * Application
 *
 * Represents a software application of any sort
 *
 * https://www.w3.org/ns/activitystreams#Application
 */
export const Application = 'https://www.w3.org/ns/activitystreams#Application';
/**
 * Arrive
 *
 * To Arrive Somewhere (can be used, for instance, to indicate that a particular entity is currently located somewhere, e.g. a "check-in")
 *
 * https://www.w3.org/ns/activitystreams#Arrive
 */
export const Arrive = 'https://www.w3.org/ns/activitystreams#Arrive';
/**
 * Article
 *
 * A written work. Typically several paragraphs long. For example, a blog post or a news article.
 *
 * https://www.w3.org/ns/activitystreams#Article
 */
export const Article = 'https://www.w3.org/ns/activitystreams#Article';
/**
 * Audio
 *
 * An audio file
 *
 * https://www.w3.org/ns/activitystreams#Audio
 */
export const Audio = 'https://www.w3.org/ns/activitystreams#Audio';
/**
 * Document
 *
 * Represents a digital document/file of any sort
 *
 * https://www.w3.org/ns/activitystreams#Document
 */
export const Document = 'https://www.w3.org/ns/activitystreams#Document';
/**
 * OrderedCollection
 *
 * A variation of Collection in which items are strictly ordered
 *
 * https://www.w3.org/ns/activitystreams#OrderedCollection
 */
export const OrderedCollection = 'https://www.w3.org/ns/activitystreams#OrderedCollection';
/**
 * Create
 *
 * To Create Something
 *
 * https://www.w3.org/ns/activitystreams#Create
 */
export const Create = 'https://www.w3.org/ns/activitystreams#Create';
/**
 * Delete
 *
 * To Delete Something
 *
 * https://www.w3.org/ns/activitystreams#Delete
 */
export const Delete = 'https://www.w3.org/ns/activitystreams#Delete';
/**
 * Dislike
 *
 * The actor dislikes the object
 *
 * https://www.w3.org/ns/activitystreams#Dislike
 */
export const Dislike = 'https://www.w3.org/ns/activitystreams#Dislike';
/**
 * Event
 *
 * An Event of any kind
 *
 * https://www.w3.org/ns/activitystreams#Event
 */
export const Event = 'https://www.w3.org/ns/activitystreams#Event';
/**
 * Flag
 *
 * To flag something (e.g. flag as inappropriate, flag as spam, etc)
 *
 * https://www.w3.org/ns/activitystreams#Flag
 */
export const Flag = 'https://www.w3.org/ns/activitystreams#Flag';
/**
 * Follow
 *
 * To Express Interest in Something
 *
 * https://www.w3.org/ns/activitystreams#Follow
 */
export const Follow = 'https://www.w3.org/ns/activitystreams#Follow';
/**
 * Group
 *
 * A Group of any kind.
 *
 * https://www.w3.org/ns/activitystreams#Group
 */
export const Group = 'https://www.w3.org/ns/activitystreams#Group';
/**
 * Invite
 *
 * To invite someone or something to something
 *
 * https://www.w3.org/ns/activitystreams#Invite
 */
export const Invite = 'https://www.w3.org/ns/activitystreams#Invite';
/**
 * Offer
 *
 * To Offer something to someone or something
 *
 * https://www.w3.org/ns/activitystreams#Offer
 */
export const Offer = 'https://www.w3.org/ns/activitystreams#Offer';
/**
 * Join
 *
 * To Join Something
 *
 * https://www.w3.org/ns/activitystreams#Join
 */
export const Join = 'https://www.w3.org/ns/activitystreams#Join';
/**
 * Leave
 *
 * To Leave Something
 *
 * https://www.w3.org/ns/activitystreams#Leave
 */
export const Leave = 'https://www.w3.org/ns/activitystreams#Leave';
/**
 * Like
 *
 * To Like Something
 *
 * https://www.w3.org/ns/activitystreams#Like
 */
export const Like = 'https://www.w3.org/ns/activitystreams#Like';
/**
 * View
 *
 * The actor viewed the object
 *
 * https://www.w3.org/ns/activitystreams#View
 */
export const View = 'https://www.w3.org/ns/activitystreams#View';
/**
 * Listen
 *
 * The actor listened to the object
 *
 * https://www.w3.org/ns/activitystreams#Listen
 */
export const Listen = 'https://www.w3.org/ns/activitystreams#Listen';
/**
 * Read
 *
 * The actor read the object
 *
 * https://www.w3.org/ns/activitystreams#Read
 */
export const Read = 'https://www.w3.org/ns/activitystreams#Read';
/**
 * Move
 *
 *
 *
 * https://www.w3.org/ns/activitystreams#Move
 */
export const Move = 'https://www.w3.org/ns/activitystreams#Move';
/**
 * Travel
 *
 *
 *
 * https://www.w3.org/ns/activitystreams#Travel
 */
export const Travel = 'https://www.w3.org/ns/activitystreams#Travel';
/**
 * Mention
 *
 * A specialized Link that represents an @mention
 *
 * https://www.w3.org/ns/activitystreams#Mention
 */
export const Mention = 'https://www.w3.org/ns/activitystreams#Mention';
/**
 * Note
 *
 * A Short note, typically less than a single paragraph. A "tweet" is an example, or a "status update"
 *
 * https://www.w3.org/ns/activitystreams#Note
 */
export const Note = 'https://www.w3.org/ns/activitystreams#Note';
/**
 * Page
 *
 * A Web Page
 *
 * https://www.w3.org/ns/activitystreams#Page
 */
export const Page = 'https://www.w3.org/ns/activitystreams#Page';
/**
 * Person
 *
 * A Person
 *
 * https://www.w3.org/ns/activitystreams#Person
 */
export const Person = 'https://www.w3.org/ns/activitystreams#Person';
/**
 * Organization
 *
 * An Organization
 *
 * https://www.w3.org/ns/activitystreams#Organization
 */
export const Organization = 'https://www.w3.org/ns/activitystreams#Organization';
/**
 * Reject
 *
 * Actor rejects the Object
 *
 * https://www.w3.org/ns/activitystreams#Reject
 */
export const Reject = 'https://www.w3.org/ns/activitystreams#Reject';
/**
 * Remove
 *
 * To Remove Something
 *
 * https://www.w3.org/ns/activitystreams#Remove
 */
export const Remove = 'https://www.w3.org/ns/activitystreams#Remove';
/**
 * Service
 *
 * A service provided by some entity
 *
 * https://www.w3.org/ns/activitystreams#Service
 */
export const Service = 'https://www.w3.org/ns/activitystreams#Service';
/**
 * TentativeAccept
 *
 * Actor tentatively accepts the Object
 *
 * https://www.w3.org/ns/activitystreams#TentativeAccept
 */
export const TentativeAccept = 'https://www.w3.org/ns/activitystreams#TentativeAccept';
/**
 * TentativeReject
 *
 * Actor tentatively rejects the object
 *
 * https://www.w3.org/ns/activitystreams#TentativeReject
 */
export const TentativeReject = 'https://www.w3.org/ns/activitystreams#TentativeReject';
/**
 * Undo
 *
 * To Undo Something. This would typically be used to indicate that a previous Activity has been undone.
 *
 * https://www.w3.org/ns/activitystreams#Undo
 */
export const Undo = 'https://www.w3.org/ns/activitystreams#Undo';
/**
 * Update
 *
 * To Update/Modify Something
 *
 * https://www.w3.org/ns/activitystreams#Update
 */
export const Update = 'https://www.w3.org/ns/activitystreams#Update';
/**
 * Video
 *
 * A Video document of any kind.
 *
 * https://www.w3.org/ns/activitystreams#Video
 */
export const Video = 'https://www.w3.org/ns/activitystreams#Video';
/**
 * actor
 *
 * Subproperty of as:attributedTo that identifies the primary actor
 *
 * https://www.w3.org/ns/activitystreams#actor
 */
export const actor = 'https://www.w3.org/ns/activitystreams#actor';
/**
 * attributedTo
 *
 * Identifies an entity to which an object is attributed
 *
 * https://www.w3.org/ns/activitystreams#attributedTo
 */
export const attributedTo = 'https://www.w3.org/ns/activitystreams#attributedTo';
/**
 * attachment
 *
 *
 *
 * https://www.w3.org/ns/activitystreams#attachment
 */
export const attachment = 'https://www.w3.org/ns/activitystreams#attachment';
/**
 * attachments
 *
 *
 *
 * https://www.w3.org/ns/activitystreams#attachments
 */
export const attachments = 'https://www.w3.org/ns/activitystreams#attachments';
/**
 * author
 *
 * Identifies the author of an object. Deprecated. Use as:attributedTo instead
 *
 * https://www.w3.org/ns/activitystreams#author
 */
export const author = 'https://www.w3.org/ns/activitystreams#author';
/**
 * bcc
 *
 *
 *
 * https://www.w3.org/ns/activitystreams#bcc
 */
export const bcc = 'https://www.w3.org/ns/activitystreams#bcc';
/**
 * bto
 *
 *
 *
 * https://www.w3.org/ns/activitystreams#bto
 */
export const bto = 'https://www.w3.org/ns/activitystreams#bto';
/**
 * cc
 *
 *
 *
 * https://www.w3.org/ns/activitystreams#cc
 */
export const cc = 'https://www.w3.org/ns/activitystreams#cc';
/**
 * context
 *
 * Specifies the context within which an object exists or an activity was performed
 *
 * https://www.w3.org/ns/activitystreams#context
 */
export const context = 'https://www.w3.org/ns/activitystreams#context';
/**
 * current
 *
 *
 *
 * https://www.w3.org/ns/activitystreams#current
 */
export const current = 'https://www.w3.org/ns/activitystreams#current';
/**
 * first
 *
 *
 *
 * https://www.w3.org/ns/activitystreams#first
 */
export const first = 'https://www.w3.org/ns/activitystreams#first';
/**
 * generator
 *
 *
 *
 * https://www.w3.org/ns/activitystreams#generator
 */
export const generator = 'https://www.w3.org/ns/activitystreams#generator';
/**
 * icon
 *
 *
 *
 * https://www.w3.org/ns/activitystreams#icon
 */
export const icon = 'https://www.w3.org/ns/activitystreams#icon';
/**
 * image
 *
 *
 *
 * https://www.w3.org/ns/activitystreams#image
 */
export const image = 'https://www.w3.org/ns/activitystreams#image';
/**
 * inReplyTo
 *
 *
 *
 * https://www.w3.org/ns/activitystreams#inReplyTo
 */
export const inReplyTo = 'https://www.w3.org/ns/activitystreams#inReplyTo';
/**
 * items
 *
 *
 *
 * https://www.w3.org/ns/activitystreams#items
 */
export const items = 'https://www.w3.org/ns/activitystreams#items';
/**
 * last
 *
 *
 *
 * https://www.w3.org/ns/activitystreams#last
 */
export const last = 'https://www.w3.org/ns/activitystreams#last';
/**
 * location
 *
 *
 *
 * https://www.w3.org/ns/activitystreams#location
 */
export const location = 'https://www.w3.org/ns/activitystreams#location';
/**
 * next
 *
 *
 *
 * https://www.w3.org/ns/activitystreams#next
 */
export const next = 'https://www.w3.org/ns/activitystreams#next';
/**
 * object
 *
 *
 *
 * https://www.w3.org/ns/activitystreams#object
 */
export const object = 'https://www.w3.org/ns/activitystreams#object';
/**
 * oneOf
 *
 * Describes a possible exclusive answer or option for a question.
 *
 * https://www.w3.org/ns/activitystreams#oneOf
 */
export const oneOf = 'https://www.w3.org/ns/activitystreams#oneOf';
/**
 * oneOf
 *
 * Describes a possible inclusive answer or option for a question.
 *
 * https://www.w3.org/ns/activitystreams#anyOf
 */
export const anyOf = 'https://www.w3.org/ns/activitystreams#anyOf';
/**
 * prev
 *
 *
 *
 * https://www.w3.org/ns/activitystreams#prev
 */
export const prev = 'https://www.w3.org/ns/activitystreams#prev';
/**
 * preview
 *
 *
 *
 * https://www.w3.org/ns/activitystreams#preview
 */
export const preview = 'https://www.w3.org/ns/activitystreams#preview';
/**
 * provider
 *
 *
 *
 * https://www.w3.org/ns/activitystreams#provider
 */
export const provider = 'https://www.w3.org/ns/activitystreams#provider';
/**
 * replies
 *
 *
 *
 * https://www.w3.org/ns/activitystreams#replies
 */
export const replies = 'https://www.w3.org/ns/activitystreams#replies';
/**
 * result
 *
 *
 *
 * https://www.w3.org/ns/activitystreams#result
 */
export const result = 'https://www.w3.org/ns/activitystreams#result';
/**
 * audience
 *
 *
 *
 * https://www.w3.org/ns/activitystreams#audience
 */
export const audience = 'https://www.w3.org/ns/activitystreams#audience';
/**
 * partOf
 *
 *
 *
 * https://www.w3.org/ns/activitystreams#partOf
 */
export const partOf = 'https://www.w3.org/ns/activitystreams#partOf';
/**
 * tag
 *
 *
 *
 * https://www.w3.org/ns/activitystreams#tag
 */
export const tag = 'https://www.w3.org/ns/activitystreams#tag';
/**
 * tags
 *
 *
 *
 * https://www.w3.org/ns/activitystreams#tags
 */
export const tags = 'https://www.w3.org/ns/activitystreams#tags';
/**
 * target
 *
 *
 *
 * https://www.w3.org/ns/activitystreams#target
 */
export const target = 'https://www.w3.org/ns/activitystreams#target';
/**
 * origin
 *
 * For certain activities, specifies the entity from which the action is directed.
 *
 * https://www.w3.org/ns/activitystreams#origin
 */
export const origin = 'https://www.w3.org/ns/activitystreams#origin';
/**
 * instrument
 *
 * Indentifies an object used (or to be used) to complete an activity
 *
 * https://www.w3.org/ns/activitystreams#instrument
 */
export const instrument = 'https://www.w3.org/ns/activitystreams#instrument';
/**
 * to
 *
 *
 *
 * https://www.w3.org/ns/activitystreams#to
 */
export const to = 'https://www.w3.org/ns/activitystreams#to';
/**
 * url
 *
 * Specifies a link to a specific representation of the Object
 *
 * https://www.w3.org/ns/activitystreams#url
 */
export const url = 'https://www.w3.org/ns/activitystreams#url';
/**
 * a
 *
 * On a Relationship object, identifies the subject. e.g. when saying "John is connected to Sally", 'subject' refers to 'John'
 *
 * https://www.w3.org/ns/activitystreams#subject
 */
export const subject = 'https://www.w3.org/ns/activitystreams#subject';
/**
 * describes
 *
 * On a Profile object, describes the object described by the profile
 *
 * https://www.w3.org/ns/activitystreams#describes
 */
export const describes = 'https://www.w3.org/ns/activitystreams#describes';
/**
 * formerType
 *
 * On a Tombstone object, describes the former type of the deleted object
 *
 * https://www.w3.org/ns/activitystreams#formerType
 */
export const formerType = 'https://www.w3.org/ns/activitystreams#formerType';
/**
 * accuracy
 *
 * Specifies the accuracy around the point established by the longitude and latitude
 *
 * https://www.w3.org/ns/activitystreams#accuracy
 */
export const accuracy = 'https://www.w3.org/ns/activitystreams#accuracy';
/**
 * altitude
 *
 * The altitude of a place
 *
 * https://www.w3.org/ns/activitystreams#altitude
 */
export const altitude = 'https://www.w3.org/ns/activitystreams#altitude';
/**
 * content
 *
 * The content of the object.
 *
 * https://www.w3.org/ns/activitystreams#content
 */
export const content = 'https://www.w3.org/ns/activitystreams#content';
/**
 * name
 *
 *
 *
 * https://www.w3.org/ns/activitystreams#name
 */
export const name = 'https://www.w3.org/ns/activitystreams#name';
/**
 * downstreamDuplicates
 *
 *
 *
 * https://www.w3.org/ns/activitystreams#downstreamDuplicates
 */
export const downstreamDuplicates = 'https://www.w3.org/ns/activitystreams#downstreamDuplicates';
/**
 * duration
 *
 * The duration of the object
 *
 * https://www.w3.org/ns/activitystreams#duration
 */
export const duration = 'https://www.w3.org/ns/activitystreams#duration';
/**
 * endTime
 *
 * The ending time of the object
 *
 * https://www.w3.org/ns/activitystreams#endTime
 */
export const endTime = 'https://www.w3.org/ns/activitystreams#endTime';
/**
 * height
 *
 * The display height expressed as device independent pixels
 *
 * https://www.w3.org/ns/activitystreams#height
 */
export const height = 'https://www.w3.org/ns/activitystreams#height';
/**
 * href
 *
 * The target URI of the Link
 *
 * https://www.w3.org/ns/activitystreams#href
 */
export const href = 'https://www.w3.org/ns/activitystreams#href';
/**
 * hreflang
 *
 * A hint about the language of the referenced resource
 *
 * https://www.w3.org/ns/activitystreams#hreflang
 */
export const hreflang = 'https://www.w3.org/ns/activitystreams#hreflang';
/**
 * id
 *
 *
 *
 * https://www.w3.org/ns/activitystreams#id
 */
export const id = 'https://www.w3.org/ns/activitystreams#id';
/**
 * latitude
 *
 * The latitude
 *
 * https://www.w3.org/ns/activitystreams#latitude
 */
export const latitude = 'https://www.w3.org/ns/activitystreams#latitude';
/**
 * longitude
 *
 * The longitude
 *
 * https://www.w3.org/ns/activitystreams#longitude
 */
export const longitude = 'https://www.w3.org/ns/activitystreams#longitude';
/**
 * mediaType
 *
 * The MIME Media Type
 *
 * https://www.w3.org/ns/activitystreams#mediaType
 */
export const mediaType = 'https://www.w3.org/ns/activitystreams#mediaType';
/**
 * objectType
 *
 *
 *
 * https://www.w3.org/ns/activitystreams#objectType
 */
export const objectType = 'https://www.w3.org/ns/activitystreams#objectType';
/**
 * published
 *
 * Specifies the date and time the object was published
 *
 * https://www.w3.org/ns/activitystreams#published
 */
export const published = 'https://www.w3.org/ns/activitystreams#published';
/**
 * radius
 *
 * Specifies a radius around the point established by the longitude and latitude
 *
 * https://www.w3.org/ns/activitystreams#radius
 */
export const radius = 'https://www.w3.org/ns/activitystreams#radius';
/**
 * rating
 *
 * A numeric rating (>= 0.0, <= 5.0) for the object
 *
 * https://www.w3.org/ns/activitystreams#rating
 */
export const rating = 'https://www.w3.org/ns/activitystreams#rating';
/**
 * rel
 *
 * The RFC 5988 or HTML5 Link Relation associated with the Link
 *
 * https://www.w3.org/ns/activitystreams#rel
 */
export const rel = 'https://www.w3.org/ns/activitystreams#rel';
/**
 * startIndex
 *
 * In a strictly ordered logical collection, specifies the index position of the first item in the items list
 *
 * https://www.w3.org/ns/activitystreams#startIndex
 */
export const startIndex = 'https://www.w3.org/ns/activitystreams#startIndex';
/**
 * startTime
 *
 * The starting time of the object
 *
 * https://www.w3.org/ns/activitystreams#startTime
 */
export const startTime = 'https://www.w3.org/ns/activitystreams#startTime';
/**
 * summary
 *
 * A short summary of the object
 *
 * https://www.w3.org/ns/activitystreams#summary
 */
export const summary = 'https://www.w3.org/ns/activitystreams#summary';
/**
 * totalItems
 *
 * The total number of items in a logical collection
 *
 * https://www.w3.org/ns/activitystreams#totalItems
 */
export const totalItems = 'https://www.w3.org/ns/activitystreams#totalItems';
/**
 * units
 *
 * Identifies the unit of measurement used by the radius, altitude and accuracy properties. The value can be expressed either as one of a set of predefined units or as a well-known common URI that identifies units.
 *
 * https://www.w3.org/ns/activitystreams#units
 */
export const units = 'https://www.w3.org/ns/activitystreams#units';
/**
 * updated
 *
 * Specifies when the object was last updated
 *
 * https://www.w3.org/ns/activitystreams#updated
 */
export const updated = 'https://www.w3.org/ns/activitystreams#updated';
/**
 * upstreamDuplicates
 *
 *
 *
 * https://www.w3.org/ns/activitystreams#upstreamDuplicates
 */
export const upstreamDuplicates = 'https://www.w3.org/ns/activitystreams#upstreamDuplicates';
/**
 * verb
 *
 *
 *
 * https://www.w3.org/ns/activitystreams#verb
 */
export const verb = 'https://www.w3.org/ns/activitystreams#verb';
/**
 * width
 *
 * Specifies the preferred display width of the content, expressed in terms of device independent pixels.
 *
 * https://www.w3.org/ns/activitystreams#width
 */
export const width = 'https://www.w3.org/ns/activitystreams#width';
/**
 * deleted
 *
 * Specifies the date and time the object was deleted
 *
 * https://www.w3.org/ns/activitystreams#deleted
 */
export const deleted = 'https://www.w3.org/ns/activitystreams#deleted';
export const _BASE = 'https://www.w3.org/ns/activitystreams#';
export const _PREFIX = 'activitystreams';
//# sourceMappingURL=activitystreams.js.map